export default __webpack_public_path__ + "static/media/LRM_EXPORT_27542315759752_20190308_080109132.b74eceb0.jpeg";